import { createContext, useContext } from 'react';

/*
  Контекст тостов: вынесен из компонента, чтобы файл компонента экспортировал только компонент.
*/

export interface ToastInput {
  title: string;
  description?: string;
  tone?: 'neutral' | 'success' | 'danger';
  /** Действие в тосте; undo: true — «Отменить», его же вызывает Ctrl+Z. */
  action?: { label: string; onClick: () => void; undo?: boolean };
  /** Сколько держится, мс (по умолчанию 5 с; с отменой — 6 с). */
  duration?: number;
}

export interface ToastApi {
  toast: (t: ToastInput) => void;
}

export const ToastContext = createContext<ToastApi>({ toast: () => {} });

export function useToast(): ToastApi {
  return useContext(ToastContext);
}
